module.exports = __webpack_public_path__ + "static/media/close-ico.540765df.svg";